import React, { useState, useEffect } from "react";
import { CSVReader } from "react-papaparse";
import { Button } from "@mui/material";
import { APIURL } from "../../../config";
import { useUtils } from "../../../utils/utilities";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import Icon from "@mui/material/Icon";
import moment from "moment";
import "./BulkUpload.css";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  myClass: {
    color: "#007bff !important",
    "&:hover": { color: "#007bee !important", cursor: "pointer" },
  },
}));

const customerColumns = [
  { field: "id", headerName: "ID", flex: 1, hide: true },
  { field: "name", headerName: "Customer Name", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "status", headerName: "Status", flex: 0.5 },
  { field: "errors", headerName: "Errors", flex: 1.75, valueGetter: (v, r) => r.errors.join() },
];

const employeeColumns = [
  { field: "id", headerName: "ID", flex: 1, hide: true },
  { field: "name", headerName: "Employee Name", flex: 1 },
  { field: "email", headerName: "Email", flex: 1 },
  { field: "status", headerName: "Status", flex: 0.5 },
  { field: "errors", headerName: "Errors", flex: 1.75, valueGetter: (v, r) => r.errors.join() },
];

const iRecordColumns = [
  { field: "id", headerName: "ID", flex: 0.5, hide: true },
  { field: "import_id", headerName: "Import ID", flex: 0.5 },
  { field: "type", headerName: "Type", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
  { field: "status", headerName: "Status", flex: 0.5 },
  { field: "errors", headerName: "Errors", flex: 1.75, valueGetter: (v, r) => r.errors.join() },
];

export default function BulkUploadv2(props) {
  const [CSVData, setCSVData] = useState();
  const [file, setFile] = useState();
  const [option, setOption] = useState("1");
  const [loading, setLoading] = useState(false);
  const [showImportButton, setShowImportButton] = useState(false);
  const [showCustomerTable, setShowCustomerTable] = useState(false);
  const [showEmployeeTable, setShowEmployeeTable] = useState(false);
  const [showIRecordTable, setShowIRecordTable] = useState(false);
  const [showReviewTable, setShowReviewTable] = useState(false);
  const [employeeRows, setEmployeeRows] = useState([]);
  const [customerRows, setCustomerRows] = useState([]);
  const [iRecordRows, setiRecordRows] = useState([]);
  const [responseMessage, setResponseMessage] = useState(null);
  const [errorAlert, setErrorAlert] = useState("");
  const [reviewRows, setReviewRows] = useState([]);
  const [reviewColumns, setReviewColumns] = useState([]);

  const { openLinkInTab } = useUtils();
  const classes = useStyles();

  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {};
    fetchData();
    return () => {
      mounted = false;
    };
  }, []);

  async function processCSV(start, end) {
    const attr = CSVData[0].data;
    const csvvals = CSVData.slice(1);
    const csvdataitems = csvvals.map((obj) => obj.data);
    const processed = csvdataitems.map((item) =>
      attr.reduce((acc, key, idx) => ({ ...acc, [key]: item[idx] }), {})
    );
    console.log(processed);
  }

  async function importCustomers() {
    const formDataPayload = new FormData();
    formDataPayload.append("filecontent", file);
    setLoading(true);

    const endpoint =
      option === "1"
        ? "bulkupload"
        : option === "2"
        ? "bulkuploadEmployee"
        : "bulkuploadCustomer";

    const resultApi = await axios.post(
      `${APIURL}/${endpoint}?company_id=${props.comp_id}&user_name=${props.user.emp_name}&emp_id=${props.user.emp_id}`,
      formDataPayload
    );

    if (resultApi.data.code === 400) {
      setErrorAlert(resultApi.data.message);
      setLoading(false);
      setResponseMessage(resultApi.data.message);
      return;
    }

    if (resultApi.data.code === 200) {
      handleSuccessResponse(resultApi.data);
    }

    setLoading(false);
    setResponseMessage(resultApi.data.message);
  }

  function handleSuccessResponse(data) {
    if (option === "1") {
      handleIRecordResponse(data.results);
    } else if (option === "2") {
      handleEmployeeResponse(data.results);
    } else if (option === "3") {
      handleCustomerResponse(data.results);
    }
  }

  function handleIRecordResponse(recordData) {
    const rows = recordData.flatMap((record, idx) => [
      {
        id: idx * 3 + 1,
        import_id: record.id,
        type: "Employee",
        description: record.EmpName,
        status: getStatus(record.caseType.charAt(0)),
        errors: record.errors.emp,
      },
      {
        id: idx * 3 + 2,
        import_id: record.id,
        type: "Customer",
        description: record.custName,
        status: getStatus(record.caseType.charAt(1)),
        errors: record.errors.cus,
      },
      {
        id: idx * 3 + 3,
        import_id: record.id,
        type: "Project",
        description: record.projName,
        status: getStatus(record.caseType.charAt(2)),
        errors: record.errors.pro,
      },
    ]);

    setiRecordRows(rows);
    setShowIRecordTable(true);
    setShowReviewTable(false);
    setShowEmployeeTable(false);
    setShowCustomerTable(false);
  }

  function handleEmployeeResponse(results) {
    const rows = [
      ...results.success.map((item, idx) => ({
        id: idx + 1,
        email: item.email,
        name: `${item.emp_first_name} ${item.emp_last_name}`,
        status: "Success",
        errors: [],
      })),
      ...results.failure.map((item, idx) => ({
        id: results.success.length + idx + 1,
        email: item.email,
        name: `${item["Employee First Name"]} ${item["Employee Last Name"]}`,
        status: "Failure",
        errors: item.errors,
      })),
    ];

    setEmployeeRows(rows);
    setShowEmployeeTable(true);
    setShowCustomerTable(false);
    setShowIRecordTable(false);
  }

  function handleCustomerResponse(results) {
    const rows = [
      ...results.success.map((item, idx) => ({
        id: idx + 1,
        email: item.Email,
        name: item.Name,
        status: "New",
        errors: [],
      })),
      ...results.update.map((item, idx) => ({
        id: results.success.length + idx + 1,
        email: item.Email,
        name: item.Name,
        status: "Updated",
        errors: [],
      })),
      ...results.failure.map((item, idx) => ({
        id: results.success.length + results.update.length + idx + 1,
        email: item.Email,
        name: item.Name,
        status: "Failure",
        errors: item.errors,
      })),
    ];

    setCustomerRows(rows);
    setShowCustomerTable(true);
    setShowEmployeeTable(false);
    setShowIRecordTable(false);
  }

  function getStatus(code) {
    return code === "0" ? "New" : code === "1" ? "Update" : "Error";
  }

  function handleOnDrop(data, file) {
    setCSVData(data);
    setFile(file);

    if (data.length > 1) {
      const headers = data[0].data;

      const columns = headers.map((header, index) => ({
        field: `col_${index}`,
        headerName: header || `Column ${index}`,
        flex: 1,
        minWidth: 150,
        editable: true,
      }));

      const rows = data
        .slice(1)
        .filter((row) => row.data.some((value) => value && value.trim() !== ""))
        .map((row, index) => ({
          id: index + 1,
          ...row.data.reduce((acc, value, colIndex) => {
            acc[`col_${colIndex}`] = value;
            return acc;
          }, {}),
        }));

      setReviewColumns(columns);
      setReviewRows(rows);
      setShowReviewTable(true);
      setShowImportButton(false);
      setShowIRecordTable(false);
    }
  }

  return (
    <div style={{ width: "100%" }}>
      <h4>Bulk Import</h4>
      <div className='mx-3' style={{ fontFamily: 'Lato', backgroundColor: 'white', marginTop: '15px', marginBottom: '15px', border: '1px solid rgb(204, 204, 204)', borderRadius: '15px', padding: '10px 10px 10px 15px' }}>
          <h6><b>How to Upload</b></h6>
          <div >
              <p style={{ display: 'inline', marginRight: '10px' }}>1. Download a template</p>
              <a style={{ display: 'inline', marginRight: '10px', fontSize: '12px'}} href="/files/FWRecord_import.csv"><i className='far fa-file'></i> FWRecord_import.csv</a>
              <a style={{ display: 'inline', marginRight: '10px', fontSize: '12px' }} href="/files/employee_import.csv"><i className='far fa-file'></i> employee_import.csv</a>
              <a style={{ display: 'inline', fontSize: '12px' }} href="/files/customer_import.csv"><i className='far fa-file'></i> customer_import.csv</a>
          </div>
          <div>
              <p style={{ display: 'inline', marginRight: '10px' }}>2. Fill out the template</p>
              <p style={{ display: 'inline', fontSize: '13px', color: 'grey',}}><i>If using Excel, make sure to export or save as a .csv</i></p>
          </div>
          <div>
              <p style={{ display: 'inline', marginRight: '10px' }}>3. Choose a file and choose import data type</p>
              <p style={{ display: 'inline', fontSize: '13px', color: 'grey',}}><i>Make sure you select the right data type to match your import file</i></p>
          </div>
          <div>
              <p style={{ display: 'inline', marginRight: '10px' }}>4. Import the file</p>
              <p style={{ display: 'inline', fontSize: '13px', color: 'grey',}}><i>If any issues found, you can fix the cells that contain errors, save the file and re-submit.</i></p>
          </div>
          <br></br>               
          <Typography variant="subtitle1">Need Support? <Link className={classes.myClass} onClick={() => openLinkInTab("https://fieldworker.tawk.help/article/how-to-import-your-data-to-fieldworker")}>Access our knowledge base</Link> or contact our support team</Typography>
      </div>
      <div className='mx-3'>
        <CSVReader
          onDrop={handleOnDrop}
          onError={(err) => console.error(err)}
          addRemoveButton
          removeButtonColor="#659cef"
          onRemoveFile={() => {
            setCSVData(null);
            setFile(null);
            setShowReviewTable(false);
            setShowImportButton(false);
          }}
        >
          <span>Drop CSV file here or click to upload.</span>
        </CSVReader>
      </div>
      <div className='mx-3' style={{ display: "flex", marginTop: "20px" }}>
        <select
          className="dropdown"
          value={option}
          onChange={(e) => setOption(e.target.value)}
          style={{
            border: "1px solid black",
            borderWidth: "2px",
            borderRadius: "15px",
            borderColor: "rgb(204, 204, 204)",
            padding: "10px",
            cursor: "pointer",
            outline: "none",
            marginBottom: "20px",
            width: "35rem",
          }}
        >
          <option value="1">Bulk import your FWRecord data</option>
          <option value="2">Bulk import your Employees</option>
          <option value="3">Bulk import your Customers</option>
        </select>

        <Button
          disabled={loading}
          onClick={importCustomers}
          variant="contained"
          sx={{
            backgroundColor: "#3FA7D6",
            marginLeft: "1.5rem",
            marginTop: "5px",
            marginBottom: "20px",
          }}
        >
          {loading ? (
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          ) : (
            "Import"
          )}
        </Button>
      </div>
      {showReviewTable && option === "1" && (
        <div style={{ width: "calc(100vw - 250px)", padding: "10px" }}>
          <h5>Preview FWRecord Data</h5>
          <DataGrid
            rows={reviewRows}
            columns={reviewColumns}
            pageSize={5}
            processRowUpdate={(newRow) => {
              setReviewRows((prevRows) =>
                prevRows.map((row) => (row.id === newRow.id ? newRow : row))
              );

              setFile((prevFile) => {
                const updatedCSVData = reviewRows.map((row) =>
                  reviewColumns.map((column) => row[column.field] || "")
                );

                const rowIndex = newRow.id - 1;
                updatedCSVData[rowIndex] = reviewColumns.map(
                  (column) => newRow[column.field] || ""
                );

                const csvHeaders = reviewColumns
                  .map((column) => column.headerName)
                  .join(",");
                const csvRows = updatedCSVData
                  .map((row) =>
                    row
                      .map((field) =>
                        field && field.includes(",")
                          ? `"${field.replace(/"/g, '""')}"`
                          : field
                      )
                      .join(",")
                  )
                  .join("\n");
                const csvContent = `${csvHeaders}\n${csvRows}`;
                const blob = new Blob([csvContent], { type: "text/csv" });
                return new File([blob], prevFile.name, { type: "text/csv" });
              });

              return newRow;
            }}
            onProcessRowUpdateError={(error) =>
              console.error("Error updating row:", error)
            }
            experimentalFeatures={{ newEditingApi: true }}
            showToolbar
          />
        </div>
      )}
      {showIRecordTable && (
        <div style={{ width: "calc(100vw - 250px)", padding: "10px"}}>
          <hr />
          <p>{responseMessage}</p>
          <DataGrid rows={iRecordRows} columns={iRecordColumns} pageSize={5} showToolbar/>
        </div>
      )}
      {showCustomerTable && (
        <div style={{ width: "calc(100vw - 250px)", padding: "10px"}}>
          <hr />
          <p>{responseMessage}</p>
          <DataGrid rows={customerRows} columns={customerColumns} pageSize={5} showToolbar/>
        </div>
      )}
      {showEmployeeTable && (
        <div style={{ width: "calc(100vw - 250px)", padding: "10px"}}>
          <hr />
          <p>{responseMessage}</p>
          <DataGrid rows={employeeRows} columns={employeeColumns} pageSize={5} showToolbar/>
        </div>
      )}
      <Snackbar
        open={!!errorAlert}
        autoHideDuration={30000}
        onClose={() => setErrorAlert("")}
      >
        <MuiAlert
          sx={{ width: "100%" }}
          severity="error"
          elevation={6}
          variant="filled"
        >
          {errorAlert}
          <IconButton
            aria-label="close"
            color="inherit"
            sx={{ p: 0.25 }}
            onClick={() => setErrorAlert("")}
          >
            <CloseIcon />
          </IconButton>
        </MuiAlert>
      </Snackbar>
    </div>
  );
}